<template>
  <div v-if="isLoggedIn" style="min-height: 100vh;">
    <v-navigation-drawer v-model="drawer" class="nav-draver" width="270" app clipped>
      <v-list v-ripple="false" dense flat>
        <v-list-item-group v-model="selectedTab" v-ripple="false" active-class="navmenu-item-active">
          <v-list-item
            v-for="menu in hasMatchedMenuRoles" :id="menu.id" :key="menu.title" v-ripple="false"
            class="my-2 " color="primary" :to="menu.link" :href="menu.href"
          >
            <v-list-item-icon v-ripple="false">
              <v-icon v-ripple="false" color="primary">
                {{ menu.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content v-ripple="false">
              <v-list-item-title v-ripple="false" class="subtitle-2 font-weight-bold">
                {{ menu.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app class="header-main" dark clipped-left>
      <v-sheet height="30" width="30" class="header-button rounded-lg">
        <v-app-bar-nav-icon height="30" width="30" @click.stop="drawer = !drawer">
          <v-icon>{{ drawer ? 'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
        </v-app-bar-nav-icon>
      </v-sheet>

      <v-img class="mx-2" :src="headerLogoUrl" max-height="35" max-width="97" contain></v-img>

      <v-spacer></v-spacer>

      <v-select
        v-if="showDevFeatures" v-model="selectedTheme" label="Select Theme" style="width: 64px"
        class="headerTextColor--text" :items="myThemes" @change="setTheme()"
      ></v-select>

      <v-menu offset-y>
        <template #activator="{ on, attrs }">
          <v-btn id="profile_button" v-bind="attrs" class="mr-4 header-button headerTextColor--text" v-on="on">
            <v-icon left>mdi-account-outline</v-icon>
            <span>{{ currentUser.email }} </span>
          </v-btn>
        </template>
        <v-list id="profile_menu">
          <v-list-item id="profile_nav_button" link color="primary" to="/user/profile">
            <v-icon class="mr-2" color="primary">mdi-cog-outline</v-icon>
            {{ $t('users.title.profile') }}
          </v-list-item>
          <v-list-item v-if="sealEnabled" id="credential_nav_button" link color="primary" to="/credentials">
            <v-icon class="mr-2" color="primary">mdi-certificate-outline</v-icon>
            {{ $t('navigationMenu.credentials') }}
          </v-list-item>

          <v-list-item id="logout_nav_button" link to="/logout">
            <v-icon class="mr-2" color="error">
              mdi-logout
            </v-icon>
            {{ $t("main.logout") }}
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container fill-height fluid>
        <v-snackbar
          v-show="mobileWarning" :timeout="-1" :value="true" multi-line centered min-width="90%"
          color="red accent-2" class="mobilewarning"
        >
          {{ $t('toastMessage.mobileWarning') }}
          <template #action="{ attrs }">
            <v-btn icon v-bind="attrs" @click="closeMobileWarning">
              <v-icon large>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <router-view>
        </router-view>
      </v-container>
    </v-main>

    <div
      class="versionBottom" :class="{ 'hidden': versionHovered }" @mouseover="versionHovered = true"
      @mouseleave="versionHoveredHandle"
    >
      <div>{{ rsspVersion }}</div>
      <div>{{ rdssVersion }}</div>
    </div>
    <vue-cookie-accept-decline
      v-if="cookiePolicyURL && (cookiePolicyURL.length > 0)" ref="rdssCookieBanner" :debug="false"
      :disable-decline="true" :show-postpone-button="false" element-id="rdssCookieBanner" position="bottom"
      transition-name="slideFromBottom" type="bar" @clicked-accept="cookieClickedAccept"
      @clicked-decline="cookieClickedDecline" @clicked-postpone="cookieClickedPostpone"
      @removed-cookie="cookieRemovedCookie" @status="cookieStatus"
    >
      <template #postponeContent>&times;</template>
      <template #message>
        {{ $t("cookie.bannerDescription") }}
        <a :href="cookiePolicyURL" target="_blank">{{
          $t("cookie.learnMore")
        }}</a>
      </template>
      <template #declineContent>{{ $t("cookie.optOut") }}</template>
      <template #acceptContent>{{ $t("cookie.acceptPolicy") }}</template>
    </vue-cookie-accept-decline>
  </div>
</template>

<script>
import seal from '@/services/api/seal.js'
import users from '@/services/api/users'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import { mapGetters } from 'vuex'
import Role from '../Role'
import { showToastError } from '../event-bus'
import rssp from '../services/api/rsspUtil'
import server from '../services/api/server'

export default {
  name: 'LayoutContent',
  components: {
    VueCookieAcceptDecline
  },

  props: {
    headerlogo: {
      type: String,
      default: undefined
    }
  },

  data() {
    const myThemesList = ['i4p', 'Quanta', 'My Company', 'From server config']
    return {
      rsspVersion: null,
      rdssVersion: null,
      showDevFeatures: false,
      selectedTab: 0,
      drawer: true,
      sealStatus: {
        enabled: false,
        secureMode: false,
        activated: false
      },
      debugModeForCredentials: false,
      cookiePolicyURL: this.$store.state.remoteConfig ? this.$store.state.remoteConfig.cookiePolicyURL : '',
      evroEnabled: this.$store.state.remoteConfig.evroEnabled ? this.$store.state.remoteConfig.evroEnabled : false,
      alfaEnabled: this.$store.state.remoteConfig.alfaEnabled ? this.$store.state.remoteConfig.alfaEnabled : false,
      trustxBackOfficeEnabled: this.$store.state.remoteConfig.trustxBackOfficeEnabled ? this.$store.state.remoteConfig.trustxBackOfficeEnabled : false,
      mobileWarning: false,
      myThemes: myThemesList,
      selectedTheme: null,
      headerLogoUrl: null,
      versionHovered: false,
      HOTJAR_SITEID: this.$store.state.remoteConfig.hotjarSiteId,
      isBAAdmin: false,
      noBAInvitations: true,
      menus: [
        {
          title: this.$t('navigationMenu.dashboard'),
          localeId: 'navigationMenu.dashboard',
          id: 'menu_dashboard',
          icon: 'mdi-view-dashboard',
          link: '/dashboard',
          allowedRoles: [Role.ADMIN, Role.USER]
        },
        {
          title: this.$t('navigationMenu.documents'),
          localeId: 'navigationMenu.documents',
          id: 'menu_documents',
          icon: 'mdi-file-document',
          link: '/signatureChains/list',
          allowedRoles: [Role.USER]
        },
        {
          title: this.$t('navigationMenu.allDocuments'),
          localeId: 'navigationMenu.allDocuments',
          id: 'menu_all_documents',
          icon: 'mdi-file-document-multiple',
          link: '/signatureChains/administrator/list',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.processInstances'),
          localeId: 'navigationMenu.processInstances',
          id: 'menu_process_instances',
          icon: 'mdi-card-account-details-outline',
          link: '/trustx/process-instances',
          allowedRoles: [Role.ADMIN],
          trustxBackOffice: true
        },
        {
          title: this.$t('navigationMenu.recycleBinDocuments'),
          localeId: 'navigationMenu.recycleBinDocuments',
          id: 'menu_recycle_bin',
          icon: 'mdi-trash-can',
          link: '/signatureChains/administrator/recycleBin',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.signatureProfiles'),
          localeId: 'navigationMenu.signatureProfiles',
          id: 'menu_signature_profiles',
          icon: 'mdi-draw-pen',
          link: '/signatureProfiles',
          allowedRoles: [Role.USER]
        },
        {
          title: this.$t('navigationMenu.usersRSSP'),
          localeId: 'navigationMenu.usersRSSP',
          id: 'menu_users',
          icon: 'mdi-account-multiple',
          link: '/users-rssp',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.users'),
          localeId: 'navigationMenu.users',
          id: 'menu_users_rdss',
          icon: 'mdi-account-multiple',
          link: '/users',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.myCredentials'),
          localeId: 'navigationMenu.myCredentials',
          id: 'menu_credentials',
          icon: 'mdi-certificate-outline',
          link: '/credentials',
          allowedRoles: [Role.USER, Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.credentialsAllAdmin'),
          localeId: 'navigationMenu.credentialsAllAdmin',
          id: 'menu_credentials_all_admin',
          icon: 'mdi-certificate-outline',
          link: '/credentialsAdmin',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.importedCredentials'),
          localeId: 'navigationMenu.importedCredentials',
          id: 'menu_import_credentials',
          icon: 'mdi-certificate-outline',
          link: '/importedCredentials',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.importedAlfaSignCredentials'),
          localeId: 'navigationMenu.importedAlfaSignCredentials',
          id: 'menu_imported_alfasign_credentials',
          icon: 'mdi-certificate-outline',
          link: '/importedAlfaSignCredentials',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.importedEvroTrustCredentials'),
          localeId: 'navigationMenu.importedEvroTrustCredentials',
          id: 'menu_imported_evrotrust_credentials',
          icon: 'mdi-certificate-outline',
          link: '/importedEvroTrustCredentials',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.devices'),
          localeId: 'navigationMenu.devices',
          id: 'menu_devices',
          icon: 'mdi-devices',
          link: '/devices-admin',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.businessAccount'),
          localeId: 'navigationMenu.businessAccount',
          id: 'menu_business_account',
          icon: 'mdi-office-building',
          link: '/business-account',
          allowedRoles: [Role.USER, Role.ADMIN],
          baAdminOnly: true
        },
        {
          title: this.$t('navigationMenu.businessAccountManagement'),
          localeId: 'navigationMenu.businessAccountManagement',
          id: 'menu_business_account_admin',
          icon: 'mdi-office-building',
          link: '/business-account-admin',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.signatureBackground'),
          localeId: 'navigationMenu.signatureBackground',
          id: 'menu_signaturebackground',
          icon: 'mdi-draw-pen',
          link: '/signature-background',
          allowedRoles: [Role.ADMIN]
        },
        {
          title: this.$t('navigationMenu.license'),
          localeId: 'navigationMenu.license',
          id: 'menu_license',
          icon: 'mdi-license',
          link: '/license',
          allowedRoles: [Role.ADMIN]
        },
        // Poorman's sign option (sphincs+ quantumsafe solution)
        {
          title: this.$t('navigationMenu.quantumSafeDemo'),
          localeId: 'navigationMenu.quantumSafeDemo',
          id: 'menu_quantumsafe_demo',
          icon: 'mdi-shield-bug-outline',
          link: '/quantum-safe-demo',
          allowedRoles: [Role.USER]
        }
      ],
      menuWithRoles: []
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    },
    isLoggedIn() {
      return !!this.$store.state.currentUser
    },
    currentUser() {
      return this.$store.state.currentUser
    },
    hasMatchedMenuRoles() {
      return this.menuWithRoles
    },
    headerLogoUrlCalced() {
      return this.headerLogoUrl
    },
    forceMobileWarningHidden() {
      return !!this.$cookies.get('forceMobileWarningHidden')
    },
    sealEnabled() {
      return this.sealStatus.enabled
    }
  },

  watch: {
    '$i18n.locale': 'updateMenuRoles',
    headerlogo(val) {
      this.headerLogoUrl = val
    }
  },

  async mounted() {
    this.sealStatus = await seal.getSealStatus()

    try {
      const me = await users.getMyUser()
      this.isBAAdmin = me.businessAccountRole === 'ADMIN'
    } catch (e) {
      this.isBAAdmin = false
    }
    const invitations = await users.getMyBusinessAccountInvitations()
    this.noBAInvitations = invitations && (invitations.businessAccounts?.length === 0)

    this.updateMenuRoles()

    try {
      const rsspVersion = await server.getRSSPVersionInfo()
      this.rsspVersion = rsspVersion.versionStringShort
      const rsspRemoteConf = await rssp.getRemoteConfig()
      this.$store.state.remoteConfig.adminOnlyCredentialManagement = rsspRemoteConf.adminOnlyCredentialManagement
    } catch (error) {
      showToastError("Can't get RSSP version info" + ' ' + error)
    }

    try {
      const rdssVersion = await server.getVersionInfo()
      this.rdssVersion = rdssVersion.versionStringShort
    } catch (error) {
      showToastError("Can't get RDSS version info" + ' ' + error)
    }

    this.headerLogoUrl = this.headerlogo
    this.checkMobileWarning()
    this.$nextTick(() => {
      window.addEventListener('resize', this.checkMobileWarning)
    })
    this.drawer = true
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobileWarning)
  },

  methods: {
    hasMatchedRoles(itemRoles, currentUserRoles) {
      const matchedRoles = currentUserRoles.filter(role => itemRoles.includes(role))
      return !!matchedRoles.length
    },

    updateMenuRoles() {
      // Recalculate the menu roles based on the new locale
      // Update the menus array with retranslated titles
      this.menus.forEach(menu => {
        menu.title = this.$t(menu.localeId)
      })
      this.menuWithRoles = this.menus.filter(item => {
        if (item.baAdminOnly) {
          return this.isBAAdmin && this.noBAInvitations
        }
        if (item.trustxBackOffice) {
          return this.isAdmin && this.trustxBackOfficeEnabled
        }

        if (item.id === 'menu_credentials') {
          if (!this.isAdmin && this.sealEnabled && !this.debugModeForCredentials) {
            return false
          }
        }
        if (item.id === 'menu_imported_evrotrust_credentials') {
          return this.isAdmin && this.evroEnabled
        }
        if (item.id === 'menu_imported_alfasign_credentials') {
          return this.isAdmin && this.alfaEnabled
        }
        return this.hasMatchedRoles(item.allowedRoles, this.$store.state.currentUser.roles)
      })

      if (!this.$store.state.remoteConfig.poorManSignEnabled) {
        const qIdx = this.menuWithRoles.findIndex(m => m.id === 'menu_quantumsafe_demo')
        if (qIdx !== -1) {
          this.menuWithRoles.splice(qIdx, 1)
        }
      }
    },

    changeRoute(route) {
      this.$router.push(route)
    },

    async logout() {
      await this.$auth.logout()
    },

    checkMobileWarning() {
      if (!this.forceMobileWarningHidden && window.innerWidth <= 600) {
        this.mobileWarning = true
      } else {
        this.mobileWarning = false
      }
    },

    closeMobileWarning() {
      this.$cookies.set('forceMobileWarningHidden', true)
      this.mobileWarning = false
    },

    setTheme(themename) {
      this.$emit('themeChanged', this.selectedTheme)
    },
    initHotjar() {},
    cookieClickedAccept() {},
    cookieClickedDecline() {},
    cookieClickedPostpone() {},
    cookieStatus(status) {
      if (status !== 'decline') {
        this.initHotjar()
      }
    },
    cookieRemovedCookie() {},
    versionHoveredHandle() {
      setTimeout(() => {
        this.versionHovered = false
      }, 2000)
    }
  }
}
</script>

<style scoped>
.hand {
  cursor: pointer;
}

.textwhite {
  color: white !important;
}

.v-tab--active {
  background-color: #fff4dc !important;
  border-radius: 5px;
  font-weight: 500;
}

.header-button {
  background-color: rgba(255, 255, 255, 0.2) !important;
}

.versionBottom {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 0;
  background-color: inherit;
  opacity: 0.65;
  font-size: 15px;
  transition: opacity 0.5s ease;
}

.versionBottom.hidden {
  z-index: -1;
  opacity: 0;
}

.hidden {
  display: none !important;
}

.mobilewarning {
  position: fixed;
  top: -40%;
  z-index: 1002;
}
</style>
